
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/ai",
      function () {
        return require("private-next-pages/site/ai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/ai"])
      });
    }
  